interface SavingsBadgeProps {
  percent: number
}

/** Green "N% SAVED" pill used in plan summaries and the card payment sheet. */
export function SavingsBadge({ percent }: SavingsBadgeProps) {
  return (
    <span className="rounded-full bg-green/20 px-2 py-1 text-[10px] font-semibold uppercase text-green">
      {percent}% Saved
    </span>
  )
}
